export default "__VITE_ASSET__BPMDPfHq__"